import {i18n} from '@yourcoach/i18n';

import InfoSVG from '../../../../assets/icons/primary/Info Circle.svg';
import {alert} from '../../../../components/alert';
import {Tooltip} from '../../../../uikit/Tooltip';
import {platform} from '../../../../utils/platform';
import * as S from './styles';

const TooltipContent = () => (
  <S.TooltipBody>
    <S.TooltipTitle>{i18n.t('shared:what_is_stripe')}</S.TooltipTitle>
    <S.TooltipContent>
      {i18n.t('shared:what_is_stripe_description')}
    </S.TooltipContent>
  </S.TooltipBody>
);

export const connectStripeConfirm = () =>
  alert.show<boolean>({
    buttons: [
      {
        label: i18n.t('shared:continue'),
        onAwaitableClick: resolve => resolve(true),
        scheme: 'primary',
      },
      {
        label: i18n.t('shared:cancel'),
        onAwaitableClick: resolve => resolve(false),
        scheme: 'gray',
      },
    ],
    icon: InfoSVG,
    iconColor: 'icon.gray',
    isDismissible: true,
    message: i18n.t('shared:CRUProgramDetails.setup_stripe_popup.description'),
    renderTitle: () => (
      <S.TitleContainer>
        <S.Title>{i18n.t('shared:stripe_account')}</S.Title>
        <Tooltip
          content={<TooltipContent />}
          place={platform.isWeb ? 'right' : 'top'}
          zPosition="aboveAlert"
        >
          <S.InfoIcon />
        </Tooltip>
      </S.TitleContainer>
    ),
  });
